'use client';

/**
 * A sticky banner shown while a platform owner is impersonating ("viewing as") a tenant.
 * Reads impersonation state from localStorage on mount (enter/exit do full reloads, so a
 * one-shot read is enough) and offers a one-click exit back to the admin account.
 */
import { useEffect, useState } from 'react';
import { Eye, LogOut } from 'lucide-react';

import { exitImpersonation, impersonatingTenantName } from '@/lib/impersonation';

export function ImpersonationBanner() {
  const [tenant, setTenant] = useState<string | null>(null);

  useEffect(() => {
    setTenant(impersonatingTenantName());
  }, []);

  if (!tenant) return null;

  return (
    <div className="sticky top-0 z-[60] flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-black">
      <Eye className="h-4 w-4 shrink-0" />
      <span className="truncate">
        Viewing <strong>{tenant}</strong> as the owner — actions you take affect this customer&apos;s account.
      </span>
      <button
        onClick={exitImpersonation}
        className="inline-flex items-center gap-1.5 rounded-md bg-black/80 px-3 py-1 text-xs font-semibold text-white hover:bg-black"
      >
        <LogOut className="h-3.5 w-3.5" /> Exit
      </button>
    </div>
  );
}
